import { AlertType } from "@/enums/Alerts";
import { WidgetType } from "../enums";

export const WidgetAlertTypes = (widgetType: WidgetType) => {
  switch (widgetType) {
    case WidgetType.ASSESSMENT_STATUS:
      return [
        AlertType.ReassessStudent,
        AlertType.ReviewTestScoring,
        AlertType.AssessmentHasReviewNeededYellowFlagging,
      ];
    case WidgetType.ASSESSMENT_OUTCOMES:
      return [AlertType.ReadingRiskFlagged];
    case WidgetType.WEEKLY_PLAN:
      return [
        AlertType.SkillGapNeedsAttention,
        AlertType.StudentSkillGapFilled,
        AlertType.LessonPlanFixNeeded,
        AlertType.AssignmentRecommended,
      ];
    case WidgetType.TUTOR_HIGHLIGHTS:
      return [
        AlertType.StudentBadgeEarned,
        AlertType.StudentNotReadingOrEngaging,
      ];
    default:
      return null;
  }
};
